import script from "./DocumentUploadList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentUploadList.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentUploadList.vue?vue&type=style&index=0&id=10315eb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10315eb2"]])

export default __exports__